/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-console */
/* global document, fetch, window */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './Hero.css';
import limitSubtitle from '../helperfunctions/limitSubtitle';

function Hero(props) {
  const { projektID } = props;

  const [projectData, setProjectData] = useState([
    {
      projekt_titel: '',
      untertitel: '',
      team: '',
      betreuer: '',
      beschreibung: '',
      project_ID: '',
    },
  ]);
  const [semester, setSemester] = useState('');
  const [teaser, setTeaser] = useState('');
  const [getVideoSource, setGetVideoSource] = useState([
    { label: '', src: '', type: '' },
  ]);
  const [windowWidth, setWindowWidth] = useState(document.body.clientWidth);

  // Fetch Data
  useEffect(() => {
    async function fetchHeroInfo() {
      const response = await fetch(
        `${process.env.REACT_APP_API}/info_ajax_for_hero?projekt_ID=${projektID}`,
      );
      return response;
    }

    async function fetchVideoSource() {
      const response = await fetch(
        `${process.env.REACT_APP_API}/video_sources_ajax?projekt_ID=${projektID}`,
      );
      return response;
    }

    fetchHeroInfo()
      .then((response) => response.json())
      .then(
        (result) => {
          setProjectData(result);
          setTeaser(limitSubtitle(result, 300));
          // eslint-disable-next-line no-use-before-define
          setSemester(
            result[0 % result.length].semester
              .replace('SS', 'Sommersemester ')
              .replace('WS', 'Wintersemester '),
          );
        },
        (error) => {
          console.log(error);
        },
      );

    fetchVideoSource()
      .then((response) => response.json())
      .then(
        (result) => {
          setGetVideoSource(result);
        },
        (error) => {
          console.log(error);
        },
      );
  }, []);

  useLayoutEffect(() => {
    function setWidth() {
      setWindowWidth(document.body.clientWidth);
    }

    // Reacting to Browser resize
    window.addEventListener('resize', setWidth());
    return () => {
      window.removeEventListener('resize', setWidth());
    };
  }, []);

  return (
    <section className="hero">
      <div className="background-video-wrapper">
        <div className="background-video-vignette" />
        {windowWidth > '500' ? (
          <video
            className="background-video"
            /* Videosource; über die Angabe #t=... kann ein Zeitfenster innerhalb des
              Video angegeben werden... */
            src={`${getVideoSource[0].src}#t=30`}
            // poster={'https://hdm-stuttgart.de/mediathek/stage_mediafiles/' + projectData[0 % projectData.length].project_ID + '/medianight_web/klein.jpg'} alt={projectData[0 % projectData.length].projekt_titel}
            muted
            autoPlay
            loop
            alt={projectData[0 % projectData.length].projekt_titel}
          />
        ) : (
          <img
            className="background-img"
            src={`https://hdm-stuttgart.de/mediathek/stage_mediafiles/${
              projectData[0 % projectData.length].project_ID
            }/medianight_web/klein.jpg`}
            alt={projectData[0 % projectData.length].projekt_titel}
          />
        )}
      </div>
      <div
        className="hero-content-wrapper"
        style={{ width: `${windowWidth - 80}px` }}
      >
        <div className="hero-titel">
          <h2>{projectData[0 % projectData.length].projekt_titel}</h2>
        </div>
        <div className="hero-projekt">
          <h3>{semester}</h3>
        </div>
        <div className="hero-beschreibung">{teaser}</div>
        <div
          className="hero-button-wrapper"
          style={{ flexDirection: windowWidth < '500' ? 'column' : 'row' }}
        >
          <Link
            to={`/mediathek/projectpage/${
              projectData[0 % projectData.length].project_ID
            }`}
            style={{ margin: '0' }}
          >
            <button type="button" className="button hero-primary-cta">
              Zur Projektseite
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;

Hero.propTypes = {
  projektID: PropTypes.number.isRequired,
};
